<div [@slideUpDown]="keepOpen || (opened$$ | async) ? 'open' : 'closed'" class="panel">
  <div class="panel-header">{{ headerTranslationKey | translate }}</div>

  <div class="panel-content">
    <glxy-form-field [bottomSpacing]="'none'">
      <input matInput [formControl]="searchQueryControl" [placeholder]="'COMMON.ACTION_LABELS.SEARCH' | translate" />
    </glxy-form-field>

    <mat-selection-list
      #sourceSelectionList
      *ngIf="filteredReviewSources$ | async as filteredReviewSources"
      class="sources-selection-list"
      (selectionChange)="onSelectionChange($event)"
    >
      <!-- Primary sources -->
      <div class="sources-category" *ngIf="filteredReviewSources.primarySourceIds.length > 0">
        <div class="category-header">{{ 'REVIEWS.SOURCE_SELECTION.PRIMARY_SOURCES' | translate }}</div>
        <ng-container *ngFor="let primarySourceId of filteredReviewSources.primarySourceIds">
          <ng-container
            *ngTemplateOutlet="
              sourceSelect;
              context: { source: filteredReviewSources.sourceInfo[primarySourceId], sourceId: primarySourceId }
            "
          ></ng-container>
        </ng-container>
      </div>

      <!-- Industry specific sources -->
      <div class="sources-category" *ngIf="filteredReviewSources.otherSourceIds.length > 0">
        <div class="category-header">{{ 'REVIEWS.SOURCE_SELECTION.INDUSTRY_SOURCES' | translate }}</div>
        <ng-container *ngFor="let otherSourceId of filteredReviewSources.otherSourceIds">
          <ng-container
            *ngTemplateOutlet="
              sourceSelect;
              context: { source: filteredReviewSources.sourceInfo[otherSourceId], sourceId: otherSourceId }
            "
          ></ng-container>
        </ng-container>
      </div>

      <ng-template #sourceSelect let-source="source" let-sourceId="sourceId">
        <!-- selected needs to be set here so that when the mat-list-option is re-rendered, the selected state is preserved -->
        <mat-list-option [value]="sourceId" [selected]="selectedSourceIds.has(sourceId)" class="source-container">
          <div class="source-label">
            <glxy-avatar [src]="source.sourceIconUrl" [width]="20" class="source-icon"></glxy-avatar>
            <span class="source-name">{{ source.sourceName }}</span>
            <span class="listing-name">{{ source.listingName }}</span>
          </div>
        </mat-list-option>
      </ng-template>
    </mat-selection-list>
  </div>
  <div class="panel-actions">
    <button (click)="onCancel()" mat-stroked-button>{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
    <button (click)="onSave()" color="primary" mat-flat-button>{{ 'COMMON.ACTION_LABELS.SAVE' | translate }}</button>
  </div>
</div>
